<script>
    export default {
        name: "MediaCardLabel",
        props: {
            type: String,
        },
    };
</script>

<template>
    <div class="media-card__label" :class="{ 'media-card__label--video': type === 'video' }">
        <slot></slot>
    </div>
</template>

<style lang="scss">
    .media-card__label {
        margin-right: 8px;
        font-weight: bold;
        font-size: 14px;
        line-height: 18px;
        padding: 3px 10px;
        color: #fff;
        z-index: 10;
        background-color: var(--media-label);
        border-radius: var(--border-xl);
    }

    //
    // --mod
    //

    .media-card__label--video {
        background-color: var(--media-label-video);
    }
</style>
